<dgx-panel-list
  [collectionName]="i18n.LearningSearch_Skills"
  [maxDisplayedItems]="5"
  [isLoading]="isLoading"
  [totalNumItems]="totalNumItems"
  [linkData]="linkData"
>
  <ul>
    <li
      *ngFor="let item of items; trackBy: trackByFn"
      data-dgat="search-skills-0e7"
    >
      <dgx-list-item [item]="item">
        <!--Item end button-->
        <button
          button
          df-button
          df-button-square
          [dfButtonType]="getButtonType(item.model.isFollowing)"
          class="guts-m-t-quart block"
          (click)="doFollowAction(item)"
          [attr.aria-label]="getButtonAriaLabel(item.model)"
          data-dgat="search-skills-666"
        >
          <df-icon
            [icon]="getButtonIcon(item.model.isFollowing)"
            size="small"
            class="center-text"
          ></df-icon>
        </button>
      </dgx-list-item>
    </li>
  </ul>
</dgx-panel-list>

<dgx-search-sidebar-no-results
  *ngIf="showNoResults"
  [collectionName]="i18n.LearningSearch_Skills"
></dgx-search-sidebar-no-results>

<dgx-search-sidebar-error
  *ngIf="showError"
  [collectionName]="i18n.LearningSearch_Skills"
></dgx-search-sidebar-error>
